import { Event_ } from '../Event_';
export class TransitionEvent_ extends Event_ {
    get propertyName() {
        return this.reactEvent.propertyName;
    }
}
